import React from "react";
import { Modal, Card } from "@mui/material";

const PdfPreviewModal = ({ open, onClose, url }) => {
    return (
        <Modal
            open={open}
            onClose={onClose}
            style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
        >
            <Card
                style={{
                    width: "50%",
                    padding: "20px",
                    display: "flex",
                    justifyContent: "center",
                    height: "80vh",
                }}
            >
                <iframe
                    src={url}
                    style={{ height: "100%", width: "100%" }}
                    title="PDF Preview"
                />
            </Card>
        </Modal>
    );
};

export default PdfPreviewModal;